export interface CountryCode {
  name: string
  iso: string
  dialCode: string
}

// Comprehensive list of country codes sorted alphabetically by name
export const COUNTRY_CODES: CountryCode[] = [
  { name: 'Afghanistan', iso: 'AF', dialCode: '+93' },
  { name: 'Albania', iso: 'AL', dialCode: '+355' },
  { name: 'Algeria', iso: 'DZ', dialCode: '+213' },
  { name: 'Andorra', iso: 'AD', dialCode: '+376' },
  { name: 'Angola', iso: 'AO', dialCode: '+244' },
  { name: 'Argentina', iso: 'AR', dialCode: '+54' },
  { name: 'Armenia', iso: 'AM', dialCode: '+374' },
  { name: 'Australia', iso: 'AU', dialCode: '+61' },
  { name: 'Austria', iso: 'AT', dialCode: '+43' },
  { name: 'Azerbaijan', iso: 'AZ', dialCode: '+994' },
  { name: 'Bahrain', iso: 'BH', dialCode: '+973' },
  { name: 'Bangladesh', iso: 'BD', dialCode: '+880' },
  { name: 'Belarus', iso: 'BY', dialCode: '+375' },
  { name: 'Belgium', iso: 'BE', dialCode: '+32' },
  { name: 'Benin', iso: 'BJ', dialCode: '+229' },
  { name: 'Bhutan', iso: 'BT', dialCode: '+975' },
  { name: 'Bolivia', iso: 'BO', dialCode: '+591' },
  { name: 'Bosnia and Herzegovina', iso: 'BA', dialCode: '+387' },
  { name: 'Botswana', iso: 'BW', dialCode: '+267' },
  { name: 'Brazil', iso: 'BR', dialCode: '+55' },
  { name: 'Brunei', iso: 'BN', dialCode: '+673' },
  { name: 'Bulgaria', iso: 'BG', dialCode: '+359' },
  { name: 'Burkina Faso', iso: 'BF', dialCode: '+226' },
  { name: 'Burundi', iso: 'BI', dialCode: '+257' },
  { name: 'Cambodia', iso: 'KH', dialCode: '+855' },
  { name: 'Cameroon', iso: 'CM', dialCode: '+237' },
  { name: 'Canada', iso: 'CA', dialCode: '+1' },
  { name: 'Cape Verde', iso: 'CV', dialCode: '+238' },
  { name: 'Central African Republic', iso: 'CF', dialCode: '+236' },
  { name: 'Chad', iso: 'TD', dialCode: '+235' },
  { name: 'Chile', iso: 'CL', dialCode: '+56' },
  { name: 'China', iso: 'CN', dialCode: '+86' },
  { name: 'Colombia', iso: 'CO', dialCode: '+57' },
  { name: 'Comoros', iso: 'KM', dialCode: '+269' },
  { name: 'Congo (DRC)', iso: 'CD', dialCode: '+243' },
  { name: 'Congo (Republic)', iso: 'CG', dialCode: '+242' },
  { name: 'Costa Rica', iso: 'CR', dialCode: '+506' },
  { name: 'Croatia', iso: 'HR', dialCode: '+385' },
  { name: 'Cuba', iso: 'CU', dialCode: '+53' },
  { name: 'Cyprus', iso: 'CY', dialCode: '+357' },
  { name: 'Czech Republic', iso: 'CZ', dialCode: '+420' },
  { name: 'Denmark', iso: 'DK', dialCode: '+45' },
  { name: 'Djibouti', iso: 'DJ', dialCode: '+253' },
  { name: 'Dominican Republic', iso: 'DO', dialCode: '+1' },
  { name: 'Ecuador', iso: 'EC', dialCode: '+593' },
  { name: 'Egypt', iso: 'EG', dialCode: '+20' },
  { name: 'El Salvador', iso: 'SV', dialCode: '+503' },
  { name: 'Equatorial Guinea', iso: 'GQ', dialCode: '+240' },
  { name: 'Eritrea', iso: 'ER', dialCode: '+291' },
  { name: 'Estonia', iso: 'EE', dialCode: '+372' },
  { name: 'Eswatini', iso: 'SZ', dialCode: '+268' },
  { name: 'Ethiopia', iso: 'ET', dialCode: '+251' },
  { name: 'Fiji', iso: 'FJ', dialCode: '+679' },
  { name: 'Finland', iso: 'FI', dialCode: '+358' },
  { name: 'France', iso: 'FR', dialCode: '+33' },
  { name: 'Gabon', iso: 'GA', dialCode: '+241' },
  { name: 'Gambia', iso: 'GM', dialCode: '+220' },
  { name: 'Georgia', iso: 'GE', dialCode: '+995' },
  { name: 'Germany', iso: 'DE', dialCode: '+49' },
  { name: 'Ghana', iso: 'GH', dialCode: '+233' },
  { name: 'Greece', iso: 'GR', dialCode: '+30' },
  { name: 'Guatemala', iso: 'GT', dialCode: '+502' },
  { name: 'Guinea', iso: 'GN', dialCode: '+224' },
  { name: 'Guinea-Bissau', iso: 'GW', dialCode: '+245' },
  { name: 'Guyana', iso: 'GY', dialCode: '+592' },
  { name: 'Haiti', iso: 'HT', dialCode: '+509' },
  { name: 'Honduras', iso: 'HN', dialCode: '+504' },
  { name: 'Hong Kong', iso: 'HK', dialCode: '+852' },
  { name: 'Hungary', iso: 'HU', dialCode: '+36' },
  { name: 'Iceland', iso: 'IS', dialCode: '+354' },
  { name: 'India', iso: 'IN', dialCode: '+91' },
  { name: 'Indonesia', iso: 'ID', dialCode: '+62' },
  { name: 'Iran', iso: 'IR', dialCode: '+98' },
  { name: 'Iraq', iso: 'IQ', dialCode: '+964' },
  { name: 'Ireland', iso: 'IE', dialCode: '+353' },
  { name: 'Israel', iso: 'IL', dialCode: '+972' },
  { name: 'Italy', iso: 'IT', dialCode: '+39' },
  { name: 'Ivory Coast', iso: 'CI', dialCode: '+225' },
  { name: 'Jamaica', iso: 'JM', dialCode: '+1' },
  { name: 'Japan', iso: 'JP', dialCode: '+81' },
  { name: 'Jordan', iso: 'JO', dialCode: '+962' },
  { name: 'Kazakhstan', iso: 'KZ', dialCode: '+7' },
  { name: 'Kenya', iso: 'KE', dialCode: '+254' },
  { name: 'Kosovo', iso: 'XK', dialCode: '+383' },
  { name: 'Kuwait', iso: 'KW', dialCode: '+965' },
  { name: 'Kyrgyzstan', iso: 'KG', dialCode: '+996' },
  { name: 'Laos', iso: 'LA', dialCode: '+856' },
  { name: 'Latvia', iso: 'LV', dialCode: '+371' },
  { name: 'Lebanon', iso: 'LB', dialCode: '+961' },
  { name: 'Lesotho', iso: 'LS', dialCode: '+266' },
  { name: 'Liberia', iso: 'LR', dialCode: '+231' },
  { name: 'Libya', iso: 'LY', dialCode: '+218' },
  { name: 'Liechtenstein', iso: 'LI', dialCode: '+423' },
  { name: 'Lithuania', iso: 'LT', dialCode: '+370' },
  { name: 'Luxembourg', iso: 'LU', dialCode: '+352' },
  { name: 'Macao', iso: 'MO', dialCode: '+853' },
  { name: 'Madagascar', iso: 'MG', dialCode: '+261' },
  { name: 'Malawi', iso: 'MW', dialCode: '+265' },
  { name: 'Malaysia', iso: 'MY', dialCode: '+60' },
  { name: 'Maldives', iso: 'MV', dialCode: '+960' },
  { name: 'Mali', iso: 'ML', dialCode: '+223' },
  { name: 'Malta', iso: 'MT', dialCode: '+356' },
  { name: 'Mauritania', iso: 'MR', dialCode: '+222' },
  { name: 'Mauritius', iso: 'MU', dialCode: '+230' },
  { name: 'Mexico', iso: 'MX', dialCode: '+52' },
  { name: 'Moldova', iso: 'MD', dialCode: '+373' },
  { name: 'Monaco', iso: 'MC', dialCode: '+377' },
  { name: 'Mongolia', iso: 'MN', dialCode: '+976' },
  { name: 'Montenegro', iso: 'ME', dialCode: '+382' },
  { name: 'Morocco', iso: 'MA', dialCode: '+212' },
  { name: 'Mozambique', iso: 'MZ', dialCode: '+258' },
  { name: 'Myanmar', iso: 'MM', dialCode: '+95' },
  { name: 'Namibia', iso: 'NA', dialCode: '+264' },
  { name: 'Nepal', iso: 'NP', dialCode: '+977' },
  { name: 'Netherlands', iso: 'NL', dialCode: '+31' },
  { name: 'New Zealand', iso: 'NZ', dialCode: '+64' },
  { name: 'Nicaragua', iso: 'NI', dialCode: '+505' },
  { name: 'Niger', iso: 'NE', dialCode: '+227' },
  { name: 'Nigeria', iso: 'NG', dialCode: '+234' },
  { name: 'North Korea', iso: 'KP', dialCode: '+850' },
  { name: 'North Macedonia', iso: 'MK', dialCode: '+389' },
  { name: 'Norway', iso: 'NO', dialCode: '+47' },
  { name: 'Oman', iso: 'OM', dialCode: '+968' },
  { name: 'Pakistan', iso: 'PK', dialCode: '+92' },
  { name: 'Palestine', iso: 'PS', dialCode: '+970' },
  { name: 'Panama', iso: 'PA', dialCode: '+507' },
  { name: 'Papua New Guinea', iso: 'PG', dialCode: '+675' },
  { name: 'Paraguay', iso: 'PY', dialCode: '+595' },
  { name: 'Peru', iso: 'PE', dialCode: '+51' },
  { name: 'Philippines', iso: 'PH', dialCode: '+63' },
  { name: 'Poland', iso: 'PL', dialCode: '+48' },
  { name: 'Portugal', iso: 'PT', dialCode: '+351' },
  { name: 'Puerto Rico', iso: 'PR', dialCode: '+1' },
  { name: 'Qatar', iso: 'QA', dialCode: '+974' },
  { name: 'Romania', iso: 'RO', dialCode: '+40' },
  { name: 'Russia', iso: 'RU', dialCode: '+7' },
  { name: 'Rwanda', iso: 'RW', dialCode: '+250' },
  { name: 'Saudi Arabia', iso: 'SA', dialCode: '+966' },
  { name: 'Senegal', iso: 'SN', dialCode: '+221' },
  { name: 'Serbia', iso: 'RS', dialCode: '+381' },
  { name: 'Sierra Leone', iso: 'SL', dialCode: '+232' },
  { name: 'Singapore', iso: 'SG', dialCode: '+65' },
  { name: 'Slovakia', iso: 'SK', dialCode: '+421' },
  { name: 'Slovenia', iso: 'SI', dialCode: '+386' },
  { name: 'Somalia', iso: 'SO', dialCode: '+252' },
  { name: 'South Africa', iso: 'ZA', dialCode: '+27' },
  { name: 'South Korea', iso: 'KR', dialCode: '+82' },
  { name: 'South Sudan', iso: 'SS', dialCode: '+211' },
  { name: 'Spain', iso: 'ES', dialCode: '+34' },
  { name: 'Sri Lanka', iso: 'LK', dialCode: '+94' },
  { name: 'Sudan', iso: 'SD', dialCode: '+249' },
  { name: 'Suriname', iso: 'SR', dialCode: '+597' },
  { name: 'Sweden', iso: 'SE', dialCode: '+46' },
  { name: 'Switzerland', iso: 'CH', dialCode: '+41' },
  { name: 'Syria', iso: 'SY', dialCode: '+963' },
  { name: 'Taiwan', iso: 'TW', dialCode: '+886' },
  { name: 'Tajikistan', iso: 'TJ', dialCode: '+992' },
  { name: 'Tanzania', iso: 'TZ', dialCode: '+255' },
  { name: 'Thailand', iso: 'TH', dialCode: '+66' },
  { name: 'Timor-Leste', iso: 'TL', dialCode: '+670' },
  { name: 'Togo', iso: 'TG', dialCode: '+228' },
  { name: 'Trinidad and Tobago', iso: 'TT', dialCode: '+1' },
  { name: 'Tunisia', iso: 'TN', dialCode: '+216' },
  { name: 'Turkey', iso: 'TR', dialCode: '+90' },
  { name: 'Turkmenistan', iso: 'TM', dialCode: '+993' },
  { name: 'Uganda', iso: 'UG', dialCode: '+256' },
  { name: 'Ukraine', iso: 'UA', dialCode: '+380' },
  { name: 'United Arab Emirates', iso: 'AE', dialCode: '+971' },
  { name: 'United Kingdom', iso: 'GB', dialCode: '+44' },
  { name: 'United States', iso: 'US', dialCode: '+1' },
  { name: 'Uruguay', iso: 'UY', dialCode: '+598' },
  { name: 'Uzbekistan', iso: 'UZ', dialCode: '+998' },
  { name: 'Venezuela', iso: 'VE', dialCode: '+58' },
  { name: 'Vietnam', iso: 'VN', dialCode: '+84' },
  { name: 'Yemen', iso: 'YE', dialCode: '+967' },
  { name: 'Zambia', iso: 'ZM', dialCode: '+260' },
  { name: 'Zimbabwe', iso: 'ZW', dialCode: '+263' },
]

// Default country code (Germany)
export const DEFAULT_COUNTRY_CODE = '+49'

// Find country by dial code
export function getCountryByDialCode(dialCode: string): CountryCode | undefined {
  return COUNTRY_CODES.find(c => c.dialCode === dialCode)
}

// Find country by ISO code
export function getCountryByIso(iso: string): CountryCode | undefined {
  return COUNTRY_CODES.find(c => c.iso === iso)
}

// Get flag emoji from ISO code
export function getFlagEmoji(iso: string): string {
  const codePoints = iso
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0))
  return String.fromCodePoint(...codePoints)
}
